class costCenters {
    constructor(
        id,
        name,
        cat,
        ws) {
        this.id = id;
        this.name = name;
        this.cat = cat;
        this.ws = ws;
    }
    static fromJson({
        csCostoId,
        nombre,
        cat,
        ws
    }) {
        return new costCenters(
            csCostoId,
            nombre,
            cat,
            ws
        );
    }
}
export default costCenters;
